import { render, staticRenderFns } from "./pekerjaanNasabah.vue?vue&type=template&id=dd61943c&"
import script from "./pekerjaanNasabah.vue?vue&type=script&lang=js&"
export * from "./pekerjaanNasabah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports